function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  const [r, g, b] = [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16)
  ]
  return [`rgb(${r},${g},${b})`, `rgba(${r},${g},${b},0.5)`, `rgba(${r},${g},${b},0)`]
}
const getSeriesMap = color => (m, index) => {
  return {
    type: 'line',
    smooth: true,
    encode: { x: 0, y: index + 1, seriesName: m, },
    // seriesLayoutBy: 'row',
    silent: false,
    areaStyle: {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: hexToRgb(color[index % color.length])[1]
        }, {
          offset: 1, color: hexToRgb(color[index % color.length])[2]
        }]
      }
    },
  }
}
const getSeries = (dataset, color) => {
  if (!dataset) return []
  let res = null
  if (dataset.dimensions) {
    res = dataset.dimensions?.filter?.((_, index) => index !== 0).map(getSeriesMap(color))
  } else {
    res = dataset.source?.[0]?.filter?.((_, index) => index !== 0).map(getSeriesMap(color))
  }
  return res || []
}
export default function Config(dataset, color) {
  const config = {
    color,
    dataset,
    legend: {
      bottom: 0,
      padding: [0, 10],
      textStyle: { color: 'var(--m-link-normal)' },
      icon: 'line',
      itemWidth: 20,
      itemHeight: 2,
    },
    tooltip: {
      show: true,
      trigger: 'axis',
      enterable: true,
      confine: true,
    },
    xAxis: {
      type: 'category',
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        align: 'center',
        margin: 10,
        padding: [0, 0, 0, 0],
        textStyle: { color: '#666995' }
      },
    },
    yAxis: {
      type: 'value',
      nameTextStyle: {
        color: 'var(--m-link-normal)',
        align: 'left',
        padding: [0, 0, 10, 0],
      },
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        textStyle: { color: '#666995' }
      },
      splitLine: {
        lineStyle: {
          color: 'var(--m-fill-1)',
          type: 'solid',
          width: 1,
        }
      }
    },
    grid: {
      containLabel: true,
      top: 50,
      right: 0,
      bottom: 32,
      left: 0,
    },
    series: getSeries(dataset, color)
  }
  return config
}
